import AdminReduce from './admin_reducer'
import UsersViewReducer from './users_view_reducer'

function reducer (state, action) {
  return UsersViewReducer(AdminReduce(state, action), action)
}

export default reducer
